import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import orgService from "./orgService";
//get user from local storage
const organization = JSON.parse(localStorage.getItem("organization"));
// const token = JSON.parse(localStorage.getItem("token"));

const initialState = {
  organization: organization ? organization : null,
  users: [],
  usage: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  templatesData: [],
  groups: [],
  tools: [],
};

//get getOrganization
export const getOrganization = createAsyncThunk(
  "organization/getOrganizationByUser",
  async (id, thunkAPI) => {
    try {
      const response = await orgService.getOrganization(id);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get getOrganization
export const get_organization_by_user = createAsyncThunk(
  "organization/get_organization_by_user",
  async (id, thunkAPI) => {
    try {
      const response = await orgService.get_organization_by_user(id);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get add new user
export const addNewUser = createAsyncThunk(
  "organization/addNewUser",
  async (userdata, thunkAPI) => {
    try {
      const response = await orgService.addNewUser(userdata);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//add users batch to organization

export const addMultipleUsers = createAsyncThunk(
  "organization/addMultipleUsers",
  async (userdata, thunkAPI) => {
    try {
      const response = await orgService.addMultipleUsers(userdata);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getAllUsers
export const getAllUsers = createAsyncThunk(
  "organization/getAllUsers",
  async (userIds, thunkAPI) => {
    try {
      // orgService.getAllUsers already handles the “empty‐array” case and returns []
      const users = await orgService.getAllUsers(userIds);
      return users; // will be an array (possibly empty)
    } catch (error) {
      // If orgService threw, grab its message and put it into rejectWithValue:
      const message =
        error.response?.data?.message || error.message || "Unknown error";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//updateUser
export const updateUser = createAsyncThunk(
  "organization/updateUser",
  async (data, thunkAPI) => {
    try {
      const response = await orgService.updateUser(data);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//deleteUser
export const deleteUser = createAsyncThunk(
  "organization/deleteUser",
  async ({ email, id }, thunkAPI) => {
    try {
      const data = await orgService.deleteUser(email);
      // We return both the backend response *and* the user‐ID we passed in:
      return { ...data, deletedId: id };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

//save org openai key
export const saveOpenAIKey = createAsyncThunk(
  "organization/saveOpenAIKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.saveOpenAIKey(orgData);
      return response;
    } catch (error) {
      // error.message is already the string we threw in the service
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//delete org openai key
export const deleteOpenAIKey = createAsyncThunk(
  "organization/deleteOpenAIKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.deleteOpenAIKey(orgData);
      return response;
    } catch (error) {
      // Since service threw new Error("<some string>"), error.message is that string.
      const message = error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete org pinecone key
export const deletePineconeKey = createAsyncThunk(
  "organization/deletePineconeKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.deletePineconeKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//save org pinecone key
export const savePineconeKey = createAsyncThunk(
  "organization/savePineconeKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.savePineconeKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete org anthropic key
export const deleteAnthropicKey = createAsyncThunk(
  "organization/deleteAnthropicKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.deleteAnthropicKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//save org anthropic key
export const saveAnthropicKey = createAsyncThunk(
  "organization/saveAnthropicKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.saveAnthropicKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete org gemini key
export const deleteGeminiKey = createAsyncThunk(
  "organization/deleteGeminiKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.deleteGeminiKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//save org gemini key
export const saveGeminiKey = createAsyncThunk(
  "organization/saveGeminiKey",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.saveGeminiKey(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete org anthropic key
export const deleteS3Credentials = createAsyncThunk(
  "organization/deleteS3Credentials",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.deleteS3Credentials(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//save org anthropic key
export const saveS3Credentials = createAsyncThunk(
  "organization/saveS3Credentials",
  async (orgData, thunkAPI) => {
    try {
      const response = await orgService.saveS3Credentials(orgData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get org usage
export const get_usage = createAsyncThunk(
  "organization/get_usage",
  async (org, thunkAPI) => {
    try {
      return await orgService.get_usage(org);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//generate api key
export const generate_APIKey = createAsyncThunk(
  "organization/generate_APIKey",
  async (org, thunkAPI) => {
    try {
      const result = await orgService.generate_APIKey(org);
      return result;
    } catch (error) {
      const message = error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete api key
export const deleteApiKey = createAsyncThunk(
  "organization/deleteApiKey",
  async (api_key, thunkAPI) => {
    try {
      const result = await orgService.deleteApiKey(api_key);
      // result is { message: "API key deleted successfully", name: key_name }
      return result;
    } catch (error) {
      // service threw new Error("<backend string>"), so error.message is that string
      const message = error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete organization
export const deleteOrganization = createAsyncThunk(
  "organization/deleteOrganization",
  async (org_id, thunkAPI) => {
    try {
      return await orgService.deleteOrganization(org_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get groups by organization
export const getGroupsByOrg = createAsyncThunk(
  "organization/getGroupsByOrg",
  async (data, thunkAPI) => {
    try {
      return await orgService.getGroupsByOrg(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get groups by user
export const getGroupsByUser = createAsyncThunk(
  "organization/getGroupsByUser",
  async (user_id, thunkAPI) => {
    try {
      return await orgService.getGroupsByUser(user_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// create org group
export const createOrgGroup = createAsyncThunk(
  "organization/createOrgGroup",
  async (data, thunkAPI) => {
    try {
      return await orgService.createOrgGroup(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// delete org group
export const deleteOrgGroup = createAsyncThunk(
  "organization/deleteOrgGroup",
  async (group_id, thunkAPI) => {
    try {
      return await orgService.deleteOrgGroup(group_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// add multiple bots to group
export const addMultipleBotsToGroup = createAsyncThunk(
  "org/addMultipleBotsToGroup",
  async (data, thunkAPI) => {
    try {
      return await orgService.addMultipleBotsToGroup(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// delete bot from group
export const deleteBotFromGroup = createAsyncThunk(
  "organization/deleteBotFromGroup",
  async (data, thunkAPI) => {
    try {
      return await orgService.deleteBotFromGroup(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// add multiple users to group
export const addMultipleUsersToGroup = createAsyncThunk(
  "groups/addMultipleUsersToGroup",
  async (data, thunkAPI) => {
    try {
      const response = await orgService.addMultipleUsersToGroup(data);
      return response;
    } catch (error) {
      // Handle errors by rejecting with the error message
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// delete user from group
export const deleteUserFromGroup = createAsyncThunk(
  "organization/deleteUserFromGroup",
  async (data, thunkAPI) => {
    try {
      return await orgService.deleteUserFromGroup(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update org llm config
export const updateLLMConfig = createAsyncThunk(
  "organization/updateLLMConfig",
  async (data, thunkAPI) => {
    try {
      return await orgService.updateLLMConfig(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get tools by organization
export const getToolsByOrg = createAsyncThunk(
  "organization/getToolsByOrg",
  async (org_id, thunkAPI) => {
    try {
      return await orgService.getToolsByOrg(org_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get tools by id
export const getToolById = createAsyncThunk(
  "organization/getToolById",
  async (tool_id, thunkAPI) => {
    try {
      return await orgService.getToolById(tool_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// save tool to library
export const saveToolToLibrary = createAsyncThunk(
  "organization/saveToolToLibrary",
  async (data, thunkAPI) => {
    try {
      return await orgService.saveToolToLibrary(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Remove tool from library
export const removeToolFromLibrary = createAsyncThunk(
  "organization/removeToolFromLibrary",
  async (tool_id, thunkAPI) => {
    try {
      return await orgService.removeToolFromLibrary(tool_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// validate mongodb
export const validateMongoDB = createAsyncThunk(
  "organization/validateMongoDB",
  async (data, thunkAPI) => {
    try {
      return await orgService.validateMongoDB(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// save mongodb
export const saveMongoDB = createAsyncThunk(
  "organization/saveMongoDB",
  async (data, thunkAPI) => {
    try {
      return await orgService.saveMongoDB(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// delete mongodb
export const deleteMongoDb = createAsyncThunk(
  "organization/deleteMongoDb",
  async (data, thunkAPI) => {
    try {
      return await orgService.deleteMongoDb(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const orgSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    adduser: (state, action) => {
      const newUsers = [...state.organization.users, action.payload];
      state.organization.users = newUsers;
    },
    resetOrganizationComplete: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
      localStorage.clear();
    },
    deleteBotFromOrg: (state, action) => {
      const newOrg = state.organization.bot.filter(
        (bot) => bot["$oid"] !== action.payload
      );
      const newTemplates = state.organization.templates.filter(
        (bot) => bot !== action.payload
      );
      const newOptimizedCombinations = state.organization.optimizedCombinations;
      if (newOptimizedCombinations[action.payload]) {
        delete newOptimizedCombinations[action.payload];
      }
      state.organization = {
        ...state.organization,
        bot: newOrg,
        templates: newTemplates,
        optimizedCombinations: newOptimizedCombinations,
      };
    },
    resetOgranization: (state) => {
      state.organization = null;
    },
    modifyKeys: (state, action) => {
      state.organization = action.payload;
    },
    saveCancelStatus: (state, action) => {
      state.organization.subscription_cancellation_status = action.payload;
    },
    setNewAppId: (state, action) => {
      state.organization.bot = [...state.organization.bot, action.payload];
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getOrganization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.organization = action.payload;
      })
      .addCase(getOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(get_organization_by_user.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(get_organization_by_user.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.organization = action.payload;
      })
      .addCase(get_organization_by_user.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addNewUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addNewUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.status;
        const status = action.payload?.status;
        if (status !== 400 && status !== 500) {
          const user = action.payload.user || {};

          // keep state.users in sync
          state.users = [...(state.users || []), user];

          // Normalize _id to a string
          const rawId =
            user?._id?.$oid ?? user?._id?.["$oid"] ?? user?._id ?? null;

          if (!state.organization) state.organization = {};
          if (!Array.isArray(state.organization.users)) {
            state.organization.users = [];
          }

          if (rawId) {
            const oidObj = { $oid: String(rawId) };
            // ✅ Avoid duplicates
            const exists = state.organization.users.some(
              (u) => u.$oid === oidObj.$oid
            );
            if (!exists) {
              state.organization.users = [...state.organization.users, oidObj];
            }
          }
        }
      })
      .addCase(addNewUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;

        // Check for a specific error status from the backend
        state.message =
          action.payload.status || "An error occurred while adding the user";
      })
      .addCase(addMultipleUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addMultipleUsers.fulfilled, (state, action) => {
        state.isLoading = false;

        // If there are errors, update the error state and message.
        if (action.payload.errors && action.payload.errors.length > 0) {
          state.isError = true;
          state.message = "Some users could not be added";
          // Optionally, store error details for further handling or display in the UI.
          state.errors = action.payload.errors;
        } else {
          state.isSuccess = true;
          state.message = "Users added successfully";
        }

        // Update users only if there are any successfully added users.
        if (action.payload.users && action.payload.users.length > 0) {
          state.users = [...state.users, ...action.payload.users];

          // Extract new user IDs and map them to the correct structure for organization.users.
          const newUserIds = action.payload.users.map((user) => ({
            $oid: user._id,
          }));
          state.organization.users = [
            ...state.organization.users,
            ...newUserIds,
          ];
        }
      })
      .addCase(addMultipleUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to add users";
      })
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.status;

        const updated = action.payload.updated;
        const email = action.meta.arg.member_email;

        state.users = state.users.map((u) =>
          u.email === email ? { ...u, ...updated } : u
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        state.message = action.payload.status || "User deleted successfully.";

        const deletedId = action.payload.deletedId;

        state.users = state.users.filter((u) => u._id["$oid"] !== deletedId);

        state.organization.users = state.organization.users.filter(
          (orgUser) => orgUser["$oid"] !== deletedId
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch users";
        state.users = [];
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.users = action.payload;
      })
      .addCase(saveOpenAIKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(saveOpenAIKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.openai_key = action.payload.data;
        state.organization.llm_keys.openai_key.key =
          action.meta.arg.keyData.apiKey;
        state.isSuccess = true;
        state.message = "OpenAI key saved.";
      })
      .addCase(saveOpenAIKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
        state.organization.llm_keys.openai_key =
          state.organization.llm_keys.openai_key ?? {};
      })
      .addCase(saveAnthropicKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
        state.organization.llm_keys.anthropic_key =
          state.organization.llm_keys.anthropic_key ?? {};
      })
      .addCase(saveAnthropicKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(saveAnthropicKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.anthropic_key = action.payload.data;
        state.organization.llm_keys.anthropic_key.key =
          action.meta.arg.keyData.key;
        state.isSuccess = true;
        state.message = "anthropic key set successfully";
      })
      .addCase(saveGeminiKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
        state.organization.llm_keys.gemini_key =
          state.organization.llm_keys.gemini_key ?? {};
      })
      .addCase(saveGeminiKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(saveGeminiKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.gemini_key = action.payload.data;
        state.isSuccess = true;
        state.message = "Gemini key saved.";
      })
      .addCase(saveS3Credentials.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(saveS3Credentials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.cloud_keys.aws = action.payload.data;
        state.isSuccess = true;
        state.message = "aws creds saved.";
      })
      .addCase(saveS3Credentials.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
        state.organization.cloud_keys.aws =
          state.organization.cloud_keys.aws ?? {};
      })
      .addCase(deleteOpenAIKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(deleteOpenAIKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.openai_key = {};
        state.isSuccess = true;
      })
      .addCase(deleteOpenAIKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deleteAnthropicKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(deleteAnthropicKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.anthropic_key = {};
        state.isSuccess = true;
      })
      .addCase(deleteAnthropicKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deleteGeminiKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(deleteGeminiKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.llm_keys.gemini_key = {};
        state.isSuccess = true;
      })
      .addCase(deleteGeminiKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deletePineconeKey.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(deletePineconeKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.pinecone_key = "";
        state.isSuccess = true;
      })
      .addCase(deletePineconeKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(savePineconeKey.pending, (state) => {
        //state.isLoading = true;
        state.isError = null;
      })
      .addCase(savePineconeKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.pinecone_key = {
          ...action.payload.data,
          key: action.payload.data.apiKey,
        };
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(savePineconeKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deleteS3Credentials.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(deleteS3Credentials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization.cloud_keys.aws = {};
        state.isSuccess = true;
      })
      .addCase(deleteS3Credentials.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(get_usage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(get_usage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.usage = action.payload.usage;
      })
      .addCase(get_usage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(generate_APIKey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(generate_APIKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        const newApiKey = action.payload;

        // Find the index of an existing API key with the same name
        const existingKeyIndex = state.organization.api_keys.findIndex(
          (key) => key.name === newApiKey.name
        );

        if (existingKeyIndex !== -1) {
          // If found, override the existing key
          state.organization.api_keys[existingKeyIndex] = newApiKey;
        } else {
          // If not found, push the new key
          state.organization.api_keys.push(newApiKey);
        }
      })
      .addCase(generate_APIKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteApiKey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteApiKey.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedKeyName = action.payload.name;
        state.organization.api_keys = state.organization.api_keys.filter(
          (key) => key.name !== deletedKeyName
        );
      })
      .addCase(deleteApiKey.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteOrganization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(deleteOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getGroupsByOrg.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(getGroupsByOrg.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.groups = action.payload.groups || [];
      })
      .addCase(getGroupsByOrg.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getGroupsByUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGroupsByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.groups = action.payload.groups || [];
      })
      .addCase(getGroupsByUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(createOrgGroup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createOrgGroup.fulfilled, (state, action) => {
        state.isLoading = false;

        const newGroupId = action.payload.group_id;
        const newGroupName = action.meta.arg.name;

        const newGroup = {
          _id: { $oid: newGroupId },
          organization: { $oid: action.meta.arg.org_id },
          name: newGroupName,
          bots: [],
          users: [action.meta.arg.owner],
        };

        state.groups.push(newGroup);
        // Ensure the organization.groups object exists
        if (!state.organization.groups) {
          state.organization.groups = {};
        }

        // Add the new group to the organization.groups object
        state.organization.groups[newGroupName] = { $oid: newGroupId };
      })
      .addCase(createOrgGroup.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deleteOrgGroup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOrgGroup.fulfilled, (state, action) => {
        state.isLoading = false;

        // Extract the group ID to be deleted
        const groupIdToDelete = action.meta.arg;

        // Remove the group from the groups array
        state.groups = state.groups.filter(
          (group) => group._id.$oid !== groupIdToDelete
        );

        // Ensure organization.groups exists before modifying it
        if (state.organization.groups) {
          // Find the group name associated with the group ID
          const groupNameToDelete = Object.keys(state.organization.groups).find(
            (name) => state.organization.groups[name].$oid === groupIdToDelete
          );

          // Delete the group from organization.groups
          if (groupNameToDelete) {
            delete state.organization.groups[groupNameToDelete];
          }
        }
      })
      .addCase(deleteOrgGroup.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload;
      })
      .addCase(deleteBotFromGroup.fulfilled, (state, action) => {
        const { group_id, bot_id } = action.meta.arg;

        // Find the group and remove the bot ID
        const group = state.groups.find((g) => g._id.$oid === group_id);
        if (group) {
          group.bots = group.bots.filter((bot) => bot.$oid !== bot_id);
        }
      })
      // in your slice file
      .addCase(addMultipleUsersToGroup.fulfilled, (state, action) => {
        const { group_id } = action.meta.arg;
        const payload = action.payload || {};

        // unwrap the array of results
        const results = Array.isArray(payload) ? payload : payload.results;
        if (!Array.isArray(results)) {
          console.error("Unexpected payload format:", payload);
          return;
        }

        // collect only the successfully‐added users
        const addedUsers = results
          .filter((r) => r.status === "User added to group successfully")
          .map((r) => ({ $oid: r.user_id }));

        // log any failures
        results
          .filter((r) => r.status !== "User added to group successfully")
          .forEach((r) => {
            console.error(`Failed to add user ${r.user_id}: ${r.status}`);
          });

        // splice them into the right group
        state.groups = state.groups.map((group) =>
          group._id.$oid === group_id
            ? { ...group, users: [...group.users, ...addedUsers] }
            : group
        );
      })
      .addCase(deleteUserFromGroup.fulfilled, (state, action) => {
        const { group_id, user_id } = action.meta.arg;

        // Find the group and remove the user ID
        const group = state.groups.find((g) => g._id.$oid === group_id);
        if (group) {
          group.users = group.users.filter((user) => user.$oid !== user_id);
        }
      })
      .addCase(addMultipleBotsToGroup.fulfilled, (state, action) => {
        const { group_id, bot_id_list } = action.meta.arg;
        const group = state.groups.find((g) => g._id.$oid === group_id);

        if (group) {
          bot_id_list.forEach((bot_id) => {
            // Prevent duplicate bot entries
            if (!group.bots.some((bot) => bot.$oid === bot_id)) {
              group.bots.push({ $oid: bot_id });
            }
          });
        }
      })
      .addCase(updateLLMConfig.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(updateLLMConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // merge the new models into the existing llm_config
        if (!state.organization) return;
        const newModels = action.meta.arg.models;
        state.organization.llm_config = {
          ...state.organization.llm_config,
          ...newModels,
        };
      })
      .addCase(updateLLMConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(getToolsByOrg.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getToolsByOrg.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const tools = action.payload.libraries;
        state.organization.tools = {
          ...state.organization.tools,
          ...tools,
        };
      })
      .addCase(getToolsByOrg.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(getToolById.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getToolById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(getToolById.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(saveToolToLibrary.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveToolToLibrary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(saveToolToLibrary.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(removeToolFromLibrary.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(removeToolFromLibrary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(removeToolFromLibrary.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(validateMongoDB.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(validateMongoDB.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(validateMongoDB.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(saveMongoDB.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveMongoDB.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(saveMongoDB.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      })
      .addCase(deleteMongoDb.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(deleteMongoDb.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(deleteMongoDb.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload || action.error.message;
        state.isSuccess = false;
        state.isError = true;
      });
  },
});
export const {
  resetOgranization,
  resetOrganizationComplete,
  adduser,
  modifyKeys,
  deleteBotFromOrg,
  saveCancelStatus,
  setNewAppId,
} = orgSlice.actions;
export default orgSlice.reducer;
